// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__7YSta","textarea":"ContactForm_textarea__TWfSj","input":"ContactForm_input__0JaZF","btn":"ContactForm_btn__WdNdn"};